import { cn } from "@/utils/helpers";
import type { TimelineStep } from "./liveModel";

const DOT: Record<TimelineStep["state"], string> = {
  done: "border-co-accent bg-co-accent",
  current: "border-co-accent",
  next: "border-co-line2",
  // Green only means live.
  live: "border-co-live",
};

const WORD: Record<TimelineStep["state"], string> = { done: "done", current: "now", next: "to come", live: "live" };

/**
 * Live / Timeline under the posts (DESIGN.md "Live"): Files in, Scheduled,
 * Live, First 24 hours. Each stop is a 10px ring (filled once done), its title
 * and one line under it, then a hairline to the next. Desktop and tablet only;
 * the phone drops it.
 */
export default function LiveTimeline({ steps }: { steps: TimelineStep[] }) {
  return (
    <ol className="!m-0 flex w-full list-none items-center gap-2.5 !p-0" aria-label="Where this post is">
      {steps.map((step, index) => (
        <li key={step.id} className="flex min-w-0 flex-1 items-center gap-2.5">
          <span aria-hidden="true" className={cn("size-2.5 shrink-0 rounded-full border-[1.5px]", DOT[step.state])} />
          <span className="flex min-w-0 flex-col gap-px">
            <span className={cn("truncate text-[13px] leading-[1.4]", step.state === "next" ? "text-co-text2" : "text-co-text")}>{step.label}</span>
            <span className="truncate text-[12px] leading-[1.3] text-co-muted">{step.sub}</span>
            <span className="sr-only">, {WORD[step.state]}</span>
          </span>
          {index < steps.length - 1 ? <span aria-hidden="true" className="h-px min-w-4 flex-1 bg-co-line" /> : null}
        </li>
      ))}
    </ol>
  );
}
